import { render, staticRenderFns } from "./ViewRequest.vue?vue&type=template&id=8975f3a6"
import script from "./ViewRequest.vue?vue&type=script&lang=js"
export * from "./ViewRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports